import { combineReducers } from 'redux';
import initialState from '../../store/initialState';

const userMaleSizes = (state = initialState.general.updateSize.userMaleSizes, action) => {
    const { type, data } = action;

    switch (type) {
        case 'SIZES_REQUEST_RECEIVED':
        case 'TEMPORARY_USER_MALE_SIZES_SAVED':
            return { ...state, ...data };
        case 'CLEAN_SIZES_FORM': {
            return {};
        }
        default: {
            return state;
        }
    }
}

const smarkMarkTemporaryMaleSizes = (state = initialState.general.updateSize.userMaleSizes, action) => {
    if (action.type == 'TEMPORARY_USER_MALE_SIZES_SAVED') {
        return { ...state, ...action.data }
    } else if (action.type == 'CLEAN_SIZES_FORM') {
        return {}
    } else {
        return state;
    }
}


const standart = (state = {}, action) => {
    if (action.type == 'STANDART_SIZES_SELECTED') {
        return { ...state, ...action.data };
    }
    return state;
}

const sizeScenario = (state = null, action) => {
    if (action.type == 'SIZE_SCENARIO_CHANGED') {
        return action.data;
    }
    return state;
}

const sizeActiveTab = (state = '', action) => {
    if (action.type == 'SIZE_TAB_CHANGED') {
        return action.data;
    }
    return state;
}

const profile = (state = {}, action) => {
    if (action.type == 'SIZES_PROFILES_SELECTED') {
        return action.data;
    }
    if (action.type == 'SIZES_PROFILES_CLEANED') {
        return {};
    }
    if (action.type == 'DEFAULT_SIZE_PROFILES_RECEIVED') {
        return action.data;
    }
    return state;
}

export default combineReducers({
    userMaleSizes,
    smarkMarkTemporaryMaleSizes,
    standart,
    profile,
    sizeScenario,
    sizeActiveTab,
});